import { render, staticRenderFns } from "./DeleteSelfiePreviewDialog.vue?vue&type=template&id=673e51be&"
import script from "./DeleteSelfiePreviewDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteSelfiePreviewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports